import React from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css"

const CustomersSection = ({ customersSectionData }) => {

	const { title, customers } = customersSectionData
	const getSrcSet = (src, width) => {
		const ratioArry = [1, 1.5, 2, 3]
		let srcSet = ""
		ratioArry.forEach(ratio => srcSet += `${src}?w=${width * ratio} ${ratio}x, `)
		return srcSet
	}
	const sliderSetting ={
		autoplay:true,
		infinite:true,
		arrows: false,
		slidesToScroll:1,
		speed:8000,
		autoplaySpeed:300,
		cssEase:"linear",
		slidesToShow:6,
		lazyload:true,
	}

	return (
		<div className={`w-screen mx-auto my-auto bg-white h-full pl-[39px] overflow-hidden pr-[36px] md:px-10 xl1:px-40 flex items-center justify-center flex-col ${title && customers ? " xl1:min-h-[326px]" : ""}`}>
			<div className="justify-center text-center ">
				{title && (
					<p
						className="text-TextCustomer py-[40px]"
						// data-sal="slide-up"
						data-sal-duration="1200"
						data-sal-delay="0"
						data-sal-easing="ease-animationSection"
					>
						Trusted by leading public safety authorities
					</p>
				)}
				{customers && (
					<div
						className="flex flex-col mb-[60px] max-w-[900px] lg:w-auto translate-y-[10px] customer-gradient"
						// data-sal="slide-up"
						// data-sal-duration="1200"
						// data-sal-delay="150"
						// data-sal-easing="ease-animationSection"
					>
					<Slider {...sliderSetting}>
						{customers?.map((v, i) => (
							<div key={`customer-${i}`}>
								<img
									srcSet={getSrcSet(v?.logo?.file?.url, 60)}
									className="customer-brand"
									alt="customers logo"
								/>
							</div>
						))}
						</Slider>
					</div>
				)}

			</div>
		</div>
	)
}

export default CustomersSection